import React from 'react'
import '../UI/Autora.css';


const Autora = () => {
  return (
    <div className='acviv d-flex align-items-center justify-content-between flex-wrap'> 
        <p><i class="ri-double-quotes-l"></i>Nació en San Miguel de Tucumán un 18 de Noviembre de 1969. Vivió siempre en su casa del barrio sur de la ciudad. Sus raíces familiares la unen también directamente a Catamarca. Egresó del secundario, sin haberlo elegido, con el título de bachiller especializado en letras. Se graduó en la Universidad Tecnológica Nacional como ingeniera en sistemas de información y luego como profesora en disciplinas industriales y especializada en entornos virtuales de aprendizaje. Todo su recorrido profesional está vinculado de diferentes maneras al área tecnológica, sin embargo, a pesar de su clara formación en ciencias exactas, su vocación por la escritura fue una constante y persiste desde la adolescencia. La Hoja Cortada, tal vez una nouvelle, es su primera pieza literaria.<i class="ri-double-quotes-r"></i></p>
    </div>
  )
}

export default Autora